// extracted by mini-css-extract-plugin
module.exports = {"fake-search-field-wrapper":"fake-search-field-wrapper__tc_pk","fake-search-field":"fake-search-field__KSc_d","clear-value-mobile":"clear-value-mobile__bhM67"};